const firebaseConfig = {
  apiKey: "AIzaSyB-jROcFT3d9wU_wlESk7a5XSxaFbHnuNc",
  authDomain: "crypto-hunter-0.firebaseapp.com",
  projectId: "crypto-hunter-0",
  storageBucket: "crypto-hunter-0.appspot.com",
  messagingSenderId: "945000302310",
  appId: "1:945000302310:web:eeaad6ceafc5736f8add27",
};

export default firebaseConfig;
